import { createContext, useContext } from 'react';
import type { TenantProfile } from '@sellokart/shared';

/**
 * P4: the report pages that consume branch/date filters have arrived
 * (ReportFilterBar, useReportFilters), so this is where the P0 comment said to
 * re-add them. The filters themselves ended up URL-synced state
 * (`useReportFilters`), not context — every report page reads its own slice of
 * the URL directly, so a context field would just be a second source of truth.
 * The one thing that DOES belong here is the branch list the filter bar's
 * dropdown needs: it now rides on `TenantProfile.branches` (from
 * `GET /portal/me`), so `profile` alone is still enough to carry it.
 */
export interface PortalContextValue {
  /** From GET /portal/me, falling back to the profile cached at login. */
  profile: TenantProfile | null;
}

const PortalContext = createContext<PortalContextValue | null>(null);

export const PortalContextProvider = PortalContext.Provider;

export function usePortal(): PortalContextValue {
  const context = useContext(PortalContext);
  if (context === null) throw new Error('usePortal must be used inside <PortalLayout>.');
  return context;
}
